import { MotionBox as Box, appearBelow, staggeredAppear } from "utils/motion";
import Text from "components/base/Text";
import Container from "components/base/Container";

export default function CardSection({
  title,
  description,
  inverted,
  supertitle,
  large,
  overlay,
  ...props
}) {
  return (
    <Box
      width="100%"
      bg={inverted ? "black.900" : "white"}
      {...props}
      title={null}
    >
      <Container small={!large}>
        <Box
          margin="auto"
          width={large ? ["100%", null, "80%"] : "100%"}
          variants={staggeredAppear}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          textAlign="center"
          mb={[8, null, 16]}
          boxShadow={
            overlay ? "0 40px 40px -40px rgba(255, 255, 255, 0.2)" : "none"
          }
          borderColor={overlay ? "green.600" : "transparent"}
          borderWidth={overlay ? "4px" : "0px"}
          bg={overlay ? "green.800" : "transparent"}
          p={overlay ? ["lg", null, "xxl"] : 0}
        >
          {supertitle && (
            <Text
              type="headline_md"
              letterSpacing={0}
              color="primary"
              variants={appearBelow}
              mb="md"
            >
              {supertitle}
            </Text>
          )}
          <Text
            type="headline_md"
            variants={appearBelow}
            mb={[4, null, 6]}
            color={inverted ? "white" : "black.900"}
          >
            {title}
          </Text>
          <Text
            type="p_md"
            variants={appearBelow}
            color={inverted ? "white" : "black.900"}
          >
            {description}
          </Text>
        </Box>
        <Box
          margin="auto"
          width={large ? "80%" : "100%"}
          variants={appearBelow}
        ></Box>
      </Container>
    </Box>
  );
}
